import { useEffect } from 'react';
import { useStore } from 'react-redux';

// reducers
import { setActiveImage } from 'hyc-store/reducers/image';

// bulma carousel
import bulmaCarousel from 'bulma-carousel';

const CarouselImage = ({ className, imgSrc, imgAlt, isCard }) => {
    const store = useStore();
    const cardClass = isCard ? 'card' : '';

    const handleClick = () => {
        store.dispatch(setActiveImage({ img: imgSrc, alt: imgAlt }));
    }

    const figureClass = [
        'image',
        className,
        'is-clickable'
    ].join(' ');

    return (
        <div>
            <div className={cardClass}>
                <div className="card-image">
                    <figure
                        className={figureClass}
                        onClick={handleClick}>
                        <img src={imgSrc} alt={imgAlt} />
                    </figure>
                </div>
            </div>
        </div>
    )
};

const Carousel = ({ id, children }) => {
    useEffect(() => {
        bulmaCarousel.attach(`#${id}`, {
            slidesToScroll: 3,
            slidesToShow: 5,
            pagination: false,
            loop: true
        });
    });

    return (
        <section className="section" style={{ overflow: 'hidden' }}>
            <div id={id} className="carousel">
                {children}
            </div>
        </section>
    );
};

export { Carousel, CarouselImage };
